import { getCurrentFirebaseUser } from './client'
import { getHanaspeakApiBaseUrl } from './functions-api'


function requirePremiumUser() {
  const user = getCurrentFirebaseUser()

  if (!user) {
    throw new Error('Not authorized')
  }

  return user
}

async function parsePremiumApiResponse(response: Response) {
  const payload = await response.json().catch(() => null) as {
    readonly activationCode?: unknown
    readonly error?: unknown
  } | null

  if (!response.ok) {
    const message = typeof payload?.error === 'string'
      ? payload.error
      : 'Premium activation failed.'

    throw new Error(message)
  }

  if (typeof payload?.activationCode !== 'string' || !payload.activationCode) {
    throw new Error('Premium activation response did not include an activation code.')
  }

  return payload.activationCode
}

async function postPremiumActivation(
  path: string,
  body: Record<string, unknown>,
) {
  const user = requirePremiumUser()
  const idToken = await user.getIdToken()
  const response = await fetch(`${getHanaspeakApiBaseUrl()}${path}`, {
    body: JSON.stringify(body),
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
    method: 'POST',
  })

  return parsePremiumApiResponse(response)
}

export interface SubmitActivationKeyInput {
  readonly activationCode: string
  readonly olderKeyId?: string | null
  readonly startAt?: number | null
}

export interface SubmitPaypalPremiumOrderInput {
  readonly currency?: string
  readonly duration: number
  readonly olderKeyId?: string | null
  readonly orderId: string
  readonly price: number
  readonly startAt: number
}

export async function submitActivationKey({
  activationCode,
  olderKeyId,
  startAt,
}: SubmitActivationKeyInput) {
  const normalizedCode = activationCode.trim()

  if (!normalizedCode) {
    throw new Error('Please enter an activation code.')
  }

  return postPremiumActivation('/premium/activation-key/activate', {
    activationCode: normalizedCode,
    olderKeyId: olderKeyId ?? null,
    startAt: startAt ?? Date.now(),
  })
}

export async function submitPaypalPremiumOrder({
  currency = 'USD',
  duration,
  olderKeyId,
  orderId,
  price,
  startAt,
}: SubmitPaypalPremiumOrderInput) {
  return postPremiumActivation('/premium/paypal/activate', {
    currency,
    duration,
    olderKeyId: olderKeyId ?? null,
    orderId,
    price,
    startAt,
  })
}
